import { mount } from "@vue/test-utils";
import CuilInput from "@/components/core/composite/combos/CuilInput";

describe("CuilInput component", () => {
  let wrapper;

  it("renderiza componente CuilInput con su componente hijo TextInput", () => {
    const valueToText = "myValue";
    wrapper = mount(CuilInput, {
      propsData: {
        value: valueToText,
        label: "inputLabel",
        hint: "hint",
        required: true,
        subhint: "subhint",
        name: "myCuilInput"
      }
    });
    // acceder a TextInput dentro de CuilInput y verificar value
    const textInput = wrapper.findComponent({ name: "TextInput" });
    const propValue = textInput.props("value");
    expect(propValue).toBe(valueToText);
  });
});
